import type { CustomReaction } from '@tribeplatform/gql-client/types'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { EntityImage } from '../../common/components/EntityImage.js'
import { convertIdToGlyph } from '../../MediaPicker/utils/utils.js'
import type { ReactionItem } from '../types.js'

export const convertToReactionItems = (
  customReactions: CustomReaction[],
): ReactionItem[] => {
  const reactionItems = customReactions.map(customReaction => {
    const {
      key,
      name,
      glyphId,
      activeColor,
      activeGlyphId,
      activeName,
      color,
    } = customReaction
    const reactionItem: ReactionItem = {
      activeColor,
      activeGlyphId,
      activeName,
      color,
      glyphId,
      key,
      name,
      id: key,
      itemIcon: glyphId ? (
        <EntityImage
          entity={{
            image: convertIdToGlyph(glyphId),
            name: name ?? '',
          }}
          size="lg"
          displayColor={customReaction.color}
        />
      ) : (
        <SvgIcon name="emotion" size="lg" />
      ),
    }

    return reactionItem
  })

  return reactionItems
}

export const convertToCustomReactions = (
  reactionItems: ReactionItem[],
): CustomReaction[] => {
  const customReactions = reactionItems.map(reactionItem => {
    const { id: _id, itemIcon: _itemIcon, ...customReaction } = reactionItem

    return customReaction
  })

  return customReactions
}

export const backfillActiveState = (
  reaction: CustomReaction,
): CustomReaction => {
  const { name, glyphId, color } = reaction
  const activeName = reaction?.activeName ?? name
  const activeGlyphId = reaction?.activeGlyphId ?? glyphId
  const activeColor = reaction?.activeColor ?? color
  const customReaction: CustomReaction = {
    ...reaction,
    activeName,
    activeGlyphId,
    activeColor,
  }

  return customReaction
}
